import React from 'react';
import './App.css';
import UIRoutes from './routes/Routes';

function App() {
  return (
    <div >
      <React.Fragment>
          <UIRoutes />
      </React.Fragment>
    </div>
  );
}

export default App;
